import { Link } from 'react-router-dom';
import { RouteMeta } from '../components/RouteMeta';

// Catch-all for URLs that match no route. Before this existed, <Routes> matched nothing and
// rendered an EMPTY page — a 200-OK blank shell at every mistyped or stale URL, which is a
// soft 404: Google crawls them, finds thin duplicate content, and the whole site's crawl
// budget and quality signals pay for it.
//
// Firebase Hosting rewrites `**` to index.html, so a real 404 status isn't available from
// static hosting. RouteMeta's noindex is the standard SPA remedy, and this at least gives a
// human somewhere to go.
export function NotFound() {
  return (
    <main style={{ maxWidth: 640, margin: '0 auto', padding: '4rem 1.25rem', textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
      <RouteMeta notFound />
      <p style={{ fontSize: '2.5rem', margin: 0 }}>🔍</p>
      <h1 style={{ fontSize: '1.5rem', color: '#1a4480', margin: '0.75rem 0 0.5rem' }}>Page not found</h1>
      <p style={{ color: '#4b5563', lineHeight: 1.6, margin: '0 0 1.5rem' }}>
        The page you're looking for doesn't exist or has moved.
      </p>
      <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/" style={{ background: '#1a4480', color: 'white', padding: '0.6rem 1.1rem', borderRadius: 8, textDecoration: 'none', fontWeight: 600 }}>
          Find a mentor
        </Link>
        <Link to="/updates" style={{ border: '1px solid #1a4480', color: '#1a4480', padding: '0.6rem 1.1rem', borderRadius: 8, textDecoration: 'none', fontWeight: 600 }}>
          Exam updates
        </Link>
      </div>
    </main>
  );
}
